import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DashboardItemCard from "./DashboardItemCard/DashboardItemCard";
import DashboardStyles from "./DashboardStyles";
import BarChartIcon from "@mui/icons-material/BarChart";
import SecurityIcon from "@mui/icons-material/Security";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { AdminDashboardCardsData, groupedModules } from "../constants";
import { useState, useEffect } from "react";

// Add function to get section icon
const getSectionIcon = (sectionTitle: string) => {
  switch (sectionTitle) {
    case "Reports":
      return <BarChartIcon sx={DashboardStyles.sectionIcon} />;
    case "UX Configs":
      return <SecurityIcon sx={DashboardStyles.sectionIcon} />;
    case "Feature Configurations":
      return <StarOutlineIcon sx={DashboardStyles.sectionIcon} />;
    default:
      return <BarChartIcon sx={DashboardStyles.sectionIcon} />;
  }
};

const Dashboard = () => {
  const isMobile = useMediaQuery("(max-width:767px)");

  return (
    <Box
      sx={DashboardStyles.dashboardContainer}
      id="admin_dashboard"
      data-test-id="admin_dashboard"
      aria-label="Admin Dashboard"
    >
      {groupedModules.map((group) => {
        const items = AdminDashboardCardsData.filter((card) =>
          group.items.includes(card.title)
        );
        return (
          <Accordion
            key={group.title}
            disableGutters
            elevation={0}
            sx={DashboardStyles.accordion}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={DashboardStyles.accordionSummary}
            >
              <Box sx={DashboardStyles.summaryContent}>
                {getSectionIcon(group.title)}
                <Typography variant="h6" sx={DashboardStyles.sectionTitle}>
                  {group.title}
                </Typography>
                <Box sx={DashboardStyles.itemCount}>{items.length} items</Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={DashboardStyles.accordionDetails}>
              <Box sx={DashboardStyles.cardsGrid}>
                {items.map((card) => (
                  <DashboardItemCard
                    key={card.title}
                    title={card.title}
                    description={card.description}
                    navigationLink={card.navigationLink}
                    iconColor={card.iconColor}
                    iconBgColor={card.iconBgColor}
                  />
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default Dashboard;
